import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/shared/http.service';
import { NewReportingFilter } from '../interfaces/new-reporting-filter';
import { min } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  constructor(private readonly httpService: HttpService) { }


  getEngineAQReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/EngineAQ?resultTimeZoneId=${timeZone}`;
    return this.httpService.post<any>(url, reportingFilter);
  }

  downloadEngineAQReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/EngineAQDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }

  getEngineMQReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/EngineMQ?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }

  downloadEngineMQReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/EngineMQDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }

  getEngineDIReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/EngineDI?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }
  downloadEngineDIReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/EngineDIDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }



  getHeightEventReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/HeightEvent?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);

  }
  downloadHeightEventReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/HeightEventDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }




  /* /Reporting/DigitalIO */
  getDigitalIOReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/DigitalIO?resultTimeZoneId=${timeZone}`;

    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined,
      IOChannels: reportingFilter.ioChannels ? reportingFilter.ioChannels : {}
    };
    return this.httpService.post<any>(url, body);
  }

  downloadDigitalIOReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/DigitalIODownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;

    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined,
      IOChannels: reportingFilter.ioChannels ? reportingFilter.ioChannels : {}
    };
    return this.httpService.postBlob(url, body);
  }

  /* /Reporting/ErrorMessage */
  getErrorMessageReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/ErrorMessage?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }

  downloadErrorMessageReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/ErrorMessageDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }

  /* /Reporting/Display */
  getDisplayReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/Display?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }

  downloadDisplayReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/DisplayDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }

  /* /Reporting/Brightness */
  getBrightnessReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/Brightness?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }
  downloadBrightnessReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/BrightnessDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }

  getTrafficDataReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/TrafficData?resultTimeZoneId=${timeZone}`;
    /* TODO: MUSS NOCH UM DEs erweitert werden */

    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      deChannels: reportingFilter.deChannels,
      Minutes: reportingFilter.minutes
    };
    return this.httpService.post<any>(url, body);
  }

  downloadTrafficDataReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/TrafficDataDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;

    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined,
      deChannels: reportingFilter.deChannels,
      Minutes: reportingFilter.minutes
    };
    return this.httpService.postBlob(url, body);
  }


  getFuelCellReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/FuelCell?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }

getFuelCellReportDownload(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/FuelCellDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }

  getEnergyReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/Energy?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }

  getEnergyReportDownload(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/EnergyDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }
/* /Reporting/Brightness */
  getWeatherDataReporting(reportingFilter: NewReportingFilter, timeZone: string) {
    const url = `Reporting/WeatherData?resultTimeZoneId=${timeZone}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.post<any>(url, body);
  }
  downloadWeatherDataReport(reportingFilter: NewReportingFilter, timeZone: string, fileType: string) {
    const url = `Reporting/WeatherDataDownload?resultTimeZoneId=${timeZone}&fileType=${fileType}`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      groupId: reportingFilter.groupId ? reportingFilter.groupId : undefined,
      projectId: reportingFilter.projectId ? reportingFilter.projectId : undefined
    };
    return this.httpService.postBlob(url, body);
  }

 /* Graphics */

  getTrafficDataGraphics(reportingFilter: NewReportingFilter) {
    const url = `Reporting/TrafficDataRaw`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      deChannels: reportingFilter.deChannels,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      Minutes: reportingFilter.minutes
    };
    return this.httpService.post<any>(url, body);
  }

  getEnergyGraphics(reportingFilter: NewReportingFilter) {
    const url = `Reporting/EnergyRaw`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined
    };
    return this.httpService.post<any>(url, body);
  }

  getDIOGraphics(reportingFilter: NewReportingFilter) {
    const url = `Reporting/DigitalIORaw`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined,
      IOChannels: reportingFilter.ioChannels ? reportingFilter.ioChannels : {} 
    };
    return this.httpService.post<any>(url, body);
  }

  getWeatherDataGraphics(reportingFilter: NewReportingFilter) {
    const url = `Reporting/WeatherDataRaw`;
    const body = {
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined
    };
    return this.httpService.post<any>(url, body);
  }







/* fuellCell Remaining calls */

/* POST
/Reporting/FuelcellRemainingFuelDashboard
Parameters

No parameters
Responses
Code	Description	Links
200	

OK
Media type
Controls Accept header.

{
  "totalDevices": 0,
  "highFuel": 0,
  "mediumFuel": 0,
  "lowFuel": 0
} */


  
  getFuelCellRemainingDashboard() {
    const url = `Reporting/FuelcellRemainingFuelDashboard`;
    return this.httpService.post<any>(url, {}); /* post mit leerem body, ich breche ab  */
  }
  
/* POST
/Reporting/FuelcellRemainingFuel
Parameters
Name	Description
resultTimeZoneId *
string
(query) */

  getFuellCellRemainingDetailData() {
    const timeZone = 'Europe/Berlin'; /* hardcoded for now */
    const url = `Reporting/FuelcellRemainingFuel?requestTimeZoneId=${timeZone}`;
    return this.httpService.post<any>(url, {}); 
  }

 getFuellCellRemainingDetailDataDownload(fileType: string) {
    const timeZone = 'Europe/Berlin'; /* hardcoded for now */
    const url = `Reporting/FuelcellRemainingFuelDownload?requestTimeZoneId=${timeZone}&fileType=${fileType}`;
    return this.httpService.post<any>(url, {}); 
 }

 getFuelCellGraphics(reportingFilter: NewReportingFilter/* , timeZone: string */) {
    const url = `Reporting/FuelcellRaw`; /* ?resultTimeZoneId=${timeZone} no timezone needed */
    const body = { 
      utcFrom: reportingFilter.utcFrom,
      utcTo: reportingFilter.utcTo,
      samId: reportingFilter.samId ? reportingFilter.samId : undefined
    };
    return this.httpService.post<any>(url, body);
  }




 /* POST
/Reporting/FuelCellCurrents
Parameters
Name	Description
deviceId *
integer($int32)
(query)
	
dateTimeUtc *
string($date-time)
(query)
	
Responses
Code	Description	Links
200	

OK
Media type
Controls Accept header.

{
  "deviceId": 0,
  "timeFuelCellDatapoint": "2025-12-18T09:25:54.131Z",
  "timeSolarChargerDatapoint": "2025-12-18T09:25:54.131Z",
  "generatorCurrent": 0,
  "solarPower": 0,
  "solarCurrentEqivalent": 0,
  "loadCurrent": 0,
  "chargerBatteryCurrent": 0,
  "fuelCellBatteryCurrent": 0,
  "evaCurrent": 0
} */

  getFuelCellCurrents(deviceId: number, dateTimeUtc: string) {
    const url = `Reporting/FuelCellCurrents?deviceId=${deviceId}&dateTimeUtc=${dateTimeUtc}`;
    return this.httpService.post<any>(url, {}); /* post mit leerem body, ich breche ab  */
  }


}